import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { ICostCategory, ICostCategoryResponse, ICostCategoryFormInputs } from "../../utils/costCategory.types";

/**
 * Fetch all cost categories
 */
export const fetchCostCategories = createAsyncThunk(
    'costCategory/fetchAll',
    async (activeOnly: boolean = true): Promise<ICostCategoryResponse> => {
        const response = await axios.get(`/api/v1/cost-categories?activeOnly=${activeOnly}`);
        return response.data;
    }
);

/**
 * Fetch cost category by ID
 */
export const fetchCostCategoryById = createAsyncThunk(
    'costCategory/fetchById',
    async (id: string): Promise<ICostCategoryResponse> => {
        const response = await axios.get(`/api/v1/cost-categories/${id}`);
        return response.data;
    }
);

/**
 * Create cost category
 */
export const createCostCategory = createAsyncThunk(
    'costCategory/create',
    async (data: ICostCategoryFormInputs): Promise<ICostCategoryResponse> => {
        const response = await axios.post(`/api/v1/cost-categories`, data);
        return response.data;
    }
);

/**
 * Update cost category
 */
export const updateCostCategory = createAsyncThunk(
    'costCategory/update',
    async ({ id, data }: { id: string; data: Partial<ICostCategoryFormInputs> }): Promise<ICostCategoryResponse> => {
        const response = await axios.put(`/api/v1/cost-categories/${id}`, data);
        return response.data;
    }
);

/**
 * Delete cost category
 */
export const deleteCostCategory = createAsyncThunk(
    'costCategory/delete',
    async (id: string): Promise<ICostCategoryResponse> => {
        const response = await axios.delete(`/api/v1/cost-categories/${id}`);
        return response.data;
    }
);
